import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Winner } from "../../../(general-header)/winners/types";
import { PrizeCollectionWinner } from "../../../collections/prize-collections/types";

interface WinnersState {
  filteredList: Winner[];
  filteredPrizeCollectionList: PrizeCollectionWinner[];
}

const initialState: WinnersState = {
  filteredList: [],
  filteredPrizeCollectionList: [],
};

export const winnersSlice = createSlice({
  name: "winners",
  initialState,
  reducers: {
    publishFilteredWinners: (state, action: PayloadAction<{ winners: Winner[] }>) => {
      state.filteredList = action.payload.winners;
    },
    publishedFilteredPrizeCollectionWinners: (state, action: PayloadAction<{ winners: PrizeCollectionWinner[] }>) => {
      state.filteredPrizeCollectionList = action.payload.winners;
    },
  },
});

export const { publishFilteredWinners, publishedFilteredPrizeCollectionWinners } = winnersSlice.actions;

export default winnersSlice.reducer;
